<div class="subscription-list-page">
  <div class="page-header">
    <h1 class="page-title">{{ 'subscriptions.list.title' | transloco }}</h1>
  </div>

  <app-spinner [loading]="loading">
    @if (loadError) {
      <div class="empty-state error-state" role="alert">
        <lucide-icon name="TriangleAlert" class="icon-em empty-icon"></lucide-icon>
        <h3>{{ 'common.states.loadError' | transloco }}</h3>
        <app-button
          [label]="'common.actions.retry' | transloco"
          variant="secondary"
          size="medium"
          (onClick)="loadSubscriptions()">
        </app-button>
      </div>
    } @else if (!loading && subscriptions.length === 0) {
      <div class="empty-state">
        <lucide-icon name="RefreshCw" class="icon-em empty-icon"></lucide-icon>
        <h3>{{ 'subscriptions.list.empty' | transloco }}</h3>
        <p>{{ 'subscriptions.list.emptySubtitle' | transloco }}</p>
        <app-button
          [label]="'subscriptions.list.createSubscription' | transloco"
          variant="primary"
          size="medium"
          routerLink="/subscriptions">
        </app-button>
      </div>
    } @else {
      <div class="subscription-cards">
        @for (sub of subscriptions; track sub.id) {
          <div class="sub-card">
            <div class="sub-card-header">
              <div class="sub-info">
                <span class="sub-product">{{ sub.product?.name || ('subscriptions.list.product' | transloco) }}</span>
                <span class="sub-platform">{{ sub.platform?.name || '' }}</span>
              </div>
              <span class="sub-status" [ngClass]="getStatusClass(getDisplayStatus(sub))">
                {{ getStatusLabel(getDisplayStatus(sub)) }}
              </span>
            </div>

            <div class="sub-card-body">
              <div class="sub-detail">
                <span class="detail-label">{{ 'subscriptions.list.progress' | transloco }}</span>
                <span class="detail-value">{{ sub.completedRuns }} / {{ sub.totalRuns }} {{ 'subscriptions.list.deliveries' | transloco }}</span>
              </div>
              <div class="sub-progress-bar">
                <div class="sub-progress-fill" [style.width.%]="(sub.completedRuns / sub.totalRuns) * 100"></div>
              </div>
              <div class="sub-detail">
                <span class="detail-label">{{ 'subscriptions.list.amountPerDelivery' | transloco }}</span>
                <span class="detail-value">{{ sub.amountPerRun | appNumber }}</span>
              </div>
              <div class="sub-detail">
                <span class="detail-label">{{ 'subscriptions.list.frequency' | transloco }}</span>
                <span class="detail-value">{{ getIntervalLabel(sub.intervalMinutes) }}</span>
              </div>
              <div class="sub-detail">
                <span class="detail-label">{{ 'subscriptions.list.totalPrice' | transloco }}</span>
                <span class="detail-value">{{ sub.totalPrice | appCurrency }}</span>
              </div>
              @if (sub.status === 'ACTIVE' && isPaid(sub) && sub.nextRunAt) {
                <div class="sub-detail">
                  <span class="detail-label">{{ 'subscriptions.list.nextDelivery' | transloco }}</span>
                  <span class="detail-value">{{ sub.nextRunAt | appDate: 'datetime' }}</span>
                </div>
              }
              <div class="sub-detail">
                <span class="detail-label">{{ 'subscriptions.list.paymentLabel' | transloco }}</span>
                <span class="detail-value">{{ getPaymentStatusLabel(sub.paymentStatus) }}</span>
              </div>
            </div>

            <div class="sub-card-actions">
              @if (awaitsApproval(sub)) {
                <app-button [label]="'subscriptions.list.approvePayment' | transloco" variant="primary" size="small" [disabled]="busyId !== null" [loading]="busyId === sub.id" (onClick)="approvePayment(sub)"></app-button>
                <app-button [label]="'subscriptions.list.rejectPayment' | transloco" variant="ghost" size="small" [disabled]="busyId !== null" (onClick)="rejectPayment(sub)"></app-button>
              }
              @if (sub.status === 'ACTIVE' && isPaid(sub)) {
                <app-button [label]="'subscriptions.list.pause' | transloco" variant="secondary" size="small" [disabled]="busyId !== null" [loading]="busyId === sub.id" (onClick)="pause(sub)"></app-button>
                <app-button [label]="'subscriptions.list.cancel' | transloco" variant="ghost" size="small" [disabled]="busyId !== null" (onClick)="cancel(sub)"></app-button>
              }
              @if (sub.status === 'PAUSED') {
                <app-button [label]="'subscriptions.list.resume' | transloco" variant="primary" size="small" [disabled]="busyId !== null" [loading]="busyId === sub.id" (onClick)="resume(sub)"></app-button>
                <app-button [label]="'subscriptions.list.cancel' | transloco" variant="ghost" size="small" [disabled]="busyId !== null" (onClick)="cancel(sub)"></app-button>
              }
            </div>
          </div>
        }
      </div>

      @if (pages > 1) {
        <div class="sub-pagination">
          <app-button [label]="'subscriptions.list.previous' | transloco" variant="tertiary" size="small" [disabled]="page === 1 || loading" (onClick)="goToPage(page - 1)"></app-button>
          <span class="sub-page-info">{{ 'subscriptions.list.pageOf' | transloco: { page: page, pages: pages } }}</span>
          <app-button [label]="'subscriptions.list.next' | transloco" variant="tertiary" size="small" [disabled]="page === pages || loading" (onClick)="goToPage(page + 1)"></app-button>
        </div>
      }
    }
  </app-spinner>
</div>
